import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import {BsModalRef} from "ngx-bootstrap/modal";
import {ViajeService} from "../../services/viaje.service";
import {ApiService} from "../../services/api.service";
import {GetDetalleViajeResponseDTO} from "../../../dtos/response/getDetalleViaje.response.dto";
import {GeneralResponseDTO} from "../../../dtos/response/general.response.dto";
import {AppMessage} from "../../app.message";
import {DetalleViajeDTO} from "../../../dtos/detalleViaje.dto";
import {ViajeDTO} from "../../../dtos/viaje.dto";
import moment from "moment";
import {NgIf} from "@angular/common";
import {HttpErrorResponse} from "@angular/common/http";
import {EventService} from "../../services/event.service";
import {PdfDTO} from "../../../dtos/pdf.dto";
import {ToastrService} from "ngx-toastr";
import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-modal-terminar-viaje-t',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './modal-terminar-viaje-t.component.html',
  styleUrl: './modal-terminar-viaje-t.component.scss'
})
export class ModalTerminarViajeTComponent {

  public viaje: ViajeDTO;
  public detalleViaje: DetalleViajeDTO;
  public procesandoPdf: boolean = false;

  constructor(private modalRef: BsModalRef, private viajeService: ViajeService, private apiService: ApiService,
              private eventService: EventService, private toastr: ToastrService, private userService: UserService) {
    this.viaje = this.viajeService.getViajeSeleccionado();
    this.getDetalleViaje();
    this.eventService.subscribe('VIAJE_ACTUALIZADO_MQTT_EVENT', (viaje: DetalleViajeDTO) => {
      if(viaje.uuid == this.viaje.uuid) {
        this.viaje = viaje;
        this.detalleViaje = viaje;
      }
    })
  }


  close() {
    this.modalRef.hide()
  }

  tienePermisoImprimirColacion(): boolean {
    return this.userService.tienePermiso('VOUCHER_COLACION');
  }

  muestraHora(fecha: string) {
    if(!fecha)
      return '';

    return moment.utc(fecha).local().format('HH:mm');
  }

  muestraDiferenciaHorasMinutos(fechaTermino: string, fechaLlegada: string) {
    if(!fechaTermino)
      return'';

    if(fechaLlegada)
      return this.muestraDiferenciaViajeTerminado(fechaTermino, fechaLlegada);

    const fecha2 = moment.utc(fechaTermino);
    const fecha1 = moment().utc();
    let diferencia = 0;
    if(fecha2 >= fecha1) {
      diferencia = fecha2.diff(fecha1);
      return moment.duration(diferencia).format('HH:mm');
    }else {
      diferencia = fecha1.diff(fecha2);
      return '+' + moment.duration(diferencia).format('HH:mm');
    }
  }

  muestraDiferenciaViajeTerminado(fechaTermino: string, fechaLlegada: string) {
    const fecha2 = moment.utc(fechaTermino);
    const fecha1 = moment.utc(fechaLlegada);
    let diferencia = 0;
    if(fecha2 >= fecha1) {
      diferencia = fecha2.diff(fecha1);
      return moment.duration(diferencia).format('HH:mm');
    }else {
      diferencia = fecha1.diff(fecha2);
      return '+' + moment.duration(diferencia).format('HH:mm');
    }
  }

  mostraHorasDisponibles() {
    if(!this.detalleViaje || !this.detalleViaje.conductor || !this.detalleViaje.conductor.jornadaEnCurso || this.detalleViaje.conductor.jornadaEnCurso.minutosRestantes == 0)
      return '00:00';

    return moment.duration(this.detalleViaje.conductor.jornadaEnCurso.minutosRestantes * 60 * 1000).format("HH:mm");
  }

  convertirMinutosEnHoras(minutos: number) {
    if(!minutos)
      return '00:00';

    return moment.duration(minutos * 60 * 1000).format("HH:mm");
  }

  getDetalleViaje() {
    this.apiService.getDetalleViaje(this.viaje.uuid).subscribe((resp) => this.getDetalleViajeSuccess(resp), (error) => this.getDetalleViajeError(error));
  }

  getDetalleViajeSuccess(getDetalleViajeResponseDTO: GetDetalleViajeResponseDTO) {
    console.log('exito detalle viaje', getDetalleViajeResponseDTO);
    this.detalleViaje = getDetalleViajeResponseDTO.data;
  }

  getDetalleViajeError(error: HttpErrorResponse) {
    console.log('error detalle viaje', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_VIAJE_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getColacionPDF() {
    this.procesandoPdf = true;
    this.apiService.getColacionPDF(this.viaje.conductor.uuid)
      .subscribe((resp) => this.getColacionPDFSuccess(resp), (error) => this.getColacionPDFError(error));
  }

  getColacionPDFSuccess(pdfDTO: PdfDTO,) {
    console.log('exito pdf');
    this.procesandoPdf = false;
    if(pdfDTO.base64Content)
      pdfDTO.generatePdfFromBase64();
    else
      this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
    //this.alertService.presentAlertaInfo(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`);
  }

  getColacionPDFError(error: HttpErrorResponse) {
    console.log('error kpis', error);
    this.procesandoPdf = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

}
